// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-callable.js
// module id = 12
// module chunks = 0